import { Button, Heading } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

type HandleConsentProps = {
  formAction: string;
};

export const HandleConsent: React.FC<HandleConsentProps> = ({ formAction }) => {
  return (
    <>
      <Heading size="md" mb="8" textAlign="center">
        Authorize
      </Heading>
      <Card p="8">
        <form action={formAction} method="post">
          <Button type="submit" w="full">
            Authorize
          </Button>
        </form>
      </Card>
    </>
  );
};
